/* eslint-disable @typescript-eslint/no-unused-vars */
// src/pages/QrCodePage.tsx
import React from "react";
import DefaultLayout from "@/wireframes/layouts/default";
import Header from "@/components/header/Header";
import Footer from "@/components/header/Footer";
import HeaderSection from "@/page-sections/home/header-section";
import GetInTouchPage from "@/page-sections/contact-us/get-in-touch-page";

const QrCodePage: React.FC = () => {
  return (
    <>
      <DefaultLayout header={<Header />} footer={<Footer />}>
        <div className="section-colors">
          <HeaderSection />
        </div>
        <div className="section-colors">
          <GetInTouchPage />
        </div>
      </DefaultLayout>
    </>
  );
};

export default QrCodePage;
